module.exports = __webpack_public_path__ + "img/detail_praised@2x.e1757e78.png";